import React, { useEffect, useState } from "react";
import { api, resolveMedia } from "@/lib/api";
import { X, Trophy, User } from "@phosphor-icons/react";

const STATS = [
  { k: "games_played", label: "GP" },
  { k: "points", label: "PTS" },
  { k: "assists", label: "AST" },
  { k: "rebounds", label: "REB" },
  { k: "blocks", label: "BLK" },
];

export function PlayerProfileModal({ player, team, onClose }) {
  const [awards, setAwards] = useState(0);

  useEffect(() => {
    api.get("/potg/leaderboard").then((r) => {
      const found = (r.data?.leaders || []).find((l) => l.player_id === player.id);
      setAwards(found ? found.awards : 0);
    }).catch(() => {});
  }, [player.id]);

  const division = team?.division || "Open";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/85 backdrop-blur-sm" onClick={onClose} data-testid="player-profile-modal">
      <div className="bg-[#121212] border border-white/10 w-full max-w-md max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="relative">
          <div className="aspect-square bg-[#0A0A0A] overflow-hidden flex items-center justify-center">
            {player.photo_url
              ? <img src={resolveMedia(player.photo_url)} alt={player.name} className="w-full h-full object-cover" data-testid="profile-photo" />
              : <User size={90} weight="fill" className="text-white/10" />}
          </div>
          <button onClick={onClose} data-testid="profile-close" className="absolute top-3 right-3 bg-black/60 hover:bg-black/80 text-white p-2 transition-colors"><X size={18} /></button>
          {player.number != null && <span className="absolute bottom-3 left-3 bg-[#FF5722] text-black font-display text-2xl px-3 py-1 tabular-nums">#{player.number}</span>}
          {awards > 0 && <span className="absolute bottom-3 right-3 bg-black/80 text-[#FF5722] text-xs font-bold uppercase tracking-wide px-2.5 py-1 flex items-center gap-1" data-testid="profile-awards"><Trophy size={13} weight="fill" /> {awards} POTG</span>}
        </div>

        <div className="p-5">
          <h3 className="font-display text-3xl uppercase leading-tight" data-testid="profile-name">{player.name}</h3>
          <p className="text-sm text-white/50 uppercase tracking-wide">{team?.name || "Free Agent"} · {division}{player.position ? ` · ${player.position}` : ""}</p>
          {player.age != null && <p className="text-xs text-white/40 mt-1" data-testid="profile-age">Age {player.age}</p>}

          <div className="grid grid-cols-5 gap-1 mt-5 border-t border-white/10 pt-4" data-testid="profile-stats">
            {STATS.map((s) => (
              <div key={s.k} className="text-center">
                <div className="font-display text-2xl text-white tabular-nums leading-none">{player[s.k] || 0}</div>
                <div className="text-[9px] uppercase tracking-wide text-white/40 mt-1">{s.label}</div>
              </div>
            ))}
          </div>

          {(player.amount_paid != null || player.balance != null) && (
            <div className="mt-4 border-t border-white/10 pt-4 flex flex-wrap gap-x-8 gap-y-2" data-testid="profile-payment">
              {player.amount_paid != null && (
                <div>
                  <div className="text-[9px] uppercase tracking-wide text-white/40">Payment Collected</div>
                  <div className="font-display text-xl text-[#00E676] tabular-nums" data-testid="profile-paid">${(Number(player.amount_paid) || 0).toFixed(2)}</div>
                </div>
              )}
              {player.balance != null && (
                <div>
                  <div className="text-[9px] uppercase tracking-wide text-white/40">Balance</div>
                  <div className={`font-display text-xl tabular-nums ${Number(player.balance) > 0 ? "text-[#FF3B30]" : "text-white/60"}`} data-testid="profile-balance">${(Number(player.balance) || 0).toFixed(2)}</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
